var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocales = function SvgLocales(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.600098 7.26667H13.9334M0.600098 7.26667C0.600098 10.9486 3.58487 13.9333 7.26676 13.9333M0.600098 7.26667C0.600098 3.58477 3.58487 0.6 7.26676 0.6M13.9334 7.26667C13.9334 10.9486 10.9487 13.9333 7.26676 13.9333M13.9334 7.26667C13.9334 3.58477 10.9487 0.6 7.26676 0.6M7.26676 0.6C8.93428 2.42557 9.88193 4.79469 9.93343 7.26667C9.88193 9.73864 8.93428 12.1078 7.26676 13.9333M7.26676 0.6C5.59924 2.42557 4.6516 4.79469 4.6001 7.26667C4.6516 9.73864 5.59924 12.1078 7.26676 13.9333",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLocales;